var map = {
	"./promo-issue-no-1_00.jpg": 66,
	"./promo-issue-no-1_01.jpg": 5087,
	"./promo-issue-no-1_02.jpg": 65,
	"./promo-issue-no-1_03.jpg": 5088,
	"./promo-issue-no-1_04.jpg": 5089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5086;